<template>
    <DashView>
        <div class="container-fluid pt-4 px-4">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <article class="col-md-12">
                                <div class="card">
                                    <div class="card-body">
                                        <h4 class="card-title font-weight-bold">Groupe: {{ info.nom }}</h4>
                                        <h6 class="card-subtitle">Description: {{ info.description }}</h6> <br>
                                        <h4 class="text-center font-weight-bold">Liste des Privillèges</h4> <br>
                                        <!-- <div v-if="privilleges.length > 0" class="p-2" :key="reloadKeyp" style="height: 450px; overflow:auto;">
                                            <div class="text-justify" v-for="(privillege, moduleName) in privilleges" :key="privillege.code_privillege">
                                                <p>
                                                    <input type="checkbox" :value="privillege.code_privillege" :checked="kodPrivGroupes.includes(privillege.code_privillege)" @click="togglePrivilleges(privillege.code_privillege)">
                                                    <h3>{{moduleName}}</h3>
                                                    <ul>
                                                        <li v-for="priv in privillege" :key="priv.code_privillege">
                                                        {{ priv.module }} : {{ priv.nom_privillege }} => {{ priv.description }}
                                                        </li>
                                                    </ul>
                                                </p>
                                                <hr>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="modal-preloader">
                                                <div class="spinner"></div>
                                            </div>
                                        </div> -->
                                        <div v-if="Object.keys(privilleges).length > 0" class="p-2" :key="reloadKeyp" style="height: 450px; overflow:auto;">
                                            <div v-for="(privilegesArray, moduleName) in privilleges" :key="moduleName" class="mb-3">
                                                <h3>{{ moduleName }}</h3>
                                                <!-- <ul> -->
                                                <p v-for="priv in privilegesArray" :key="priv.code_privillege">
                                                    <input
                                                    type="checkbox"
                                                    :value="priv.code_privillege"
                                                    :checked="kodPrivGroupes.includes(priv.code_privillege)"
                                                    @click="togglePrivilleges(priv.code_privillege)">
                                                    {{ priv.module }} => {{ priv.nom_privillege }}
                                                </p>
                                                <!-- </ul> -->
                                                <hr>
                                            </div>
                                        </div>
                                        <div v-else>
                                        <div class="modal-preloader">
                                            <div class="spinner"></div>
                                        </div>
                                        </div>

                                    </div>
                                </div>
                            </article>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <article class="col-md-12">
                                <div class="card">
                                    <div class="card-body">
                                        <h4 class="card-title font-weight-bold">Groupe: {{ info.nom }}</h4>
                                        <h6 class="card-subtitle">Description: {{ info.description }}</h6> <br>
                                        <h4 class="text-center font-weight-bold"><i class="fa fa-plus" @click="loadAllUsers" data-bs-toggle="modal" title="Ajouter utilisateurs dans le groupe" data-bs-target="#umyModal"></i> &nbsp;Liste des utilisateurs du groupe</h4> <br>
                                        <div v-if="groupUsers.length > 0" class="p-2" :key="reloadKey" style="height: 450px; overflow:auto;">
                                            <div class="text-justify" v-for="(user,key) in groupUsers" :key="key">
                                                <p>
                                                    <input type="checkbox" checked :value="user.code_utilisateur" @click="removeUserFromGroup(user.code_utilisateur)">
                                                    {{ user.nom_utilisateur }} {{ user.prenom_utilisateur }}
                                                </p>
                                                <hr>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="text-center">Aucun utilisateur!</div>
                                            <div class="modal-preloader">
                                                <div class="spinner"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>
        </div>
        <br>
        <br>
    </DashView>
    <!-- All Modal -->
        <!-- Start Modal Add user in group-->        
        <div class="modal fade" id="umyModal">
            <div class="modal-dialog">
                <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Ajouter utilisateur</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div class="alert alert-success text-success" v-if="message_addUser">{{message_addUser}}</div>
                    <form action="">
                        <div class="row">
                            <div class="col-md-6 form-group">
                                <select ref="selectUser" class="select2" autofocus="true" style="height: 200px; width: 300px; text-align: center;">
                                    <option value="">----Utilisateurs----</option>
                                    <template v-if="availableUsers.length > 0">
                                        <option class="text-center" v-for="(user,key) in availableUsers" :key="key" :value="user.id">{{ user.nom }} {{ user.prenom }}</option>
                                    </template>
                                    <template v-else>
                                        <option value="">Aucun Utilisateur trouvé!</option>
                                    </template>
                                </select>  
                            </div>
                            <div class="offset-2 col-md-4">
                                <button class="btn btn-primary" type="button" @click="addUserFromGroup">Ajouter</button>
                            </div>
                        </div>
                    </form>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" id="closeModalAddUserInGroup" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                </div>

                </div>
            </div>
        </div>
        <!-- End Modal Add user in group-->
    <!-- End ALL modal -->
</template>
<script>
import DashView from "@/components/DashView.vue"
import axios from 'axios'
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2.min.js';
  import $ from 'jquery';
  const base_url=process.env.VUE_APP_API_URL;
export default {
    name:"GroupUpdate",
    components:{
        DashView
    },
    data(){
      return{
        privilleges:[],
        reloadKey:0,
        reloadKeyp:0,
        kodPrivGroupes:[],
        users:[],
        kodUserForAdd:null,
        message_addUser:null,
        groupUsers:[],
        accessToken : JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
        info:{
            id:'',
            nom:'',
            description:'',
            nom_user:'',
            prenom_user:'',
            date_creation:''
        },
          success_msg:'',
          validationErrors:[],
          form :{
          nom: '',
          description: '',
        },
        alertName:'',
        regexNonVide:/^\s*$/
      }
  },
  methods:{
    addPrivilleges(code_priv){
          const $data ={
              groupe_id : +this.info.id,
              privillege_id : +code_priv
            };
        // console.log($data);
          axios.post(`${base_url}/addPrivillegeGroup`,$data,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
          .then((response)=>{
            //   console.log(response.data);
              if(response?.status==200){
                this.loadGroupPrivilleges();
                this.loadAllPrivilleges();
              }
          })
          .catch((error)=>{
            if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
                    this.reloadKeyp+=1;
            }
            else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
            }
                
          })
    },
    removePrivilleges(code_priv){

          const $data ={
              groupe_id : +this.info.id,
              privillege_id : +code_priv
            };
        // console.log($data);
          axios.post(`${base_url}/removePrivillegeGroup`,$data,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
          .then((response)=>{
            //   console.log(response.data);
              if(response?.status==200){
                this.loadGroupPrivilleges();
                this.loadAllPrivilleges();
              }
          })
          .catch((error)=>{
            if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalButton').trigger('click');
                    let self = this;
                    setTimeout(function() {
                        location.reload();
                    },2000);
            }
            else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
            }
                
          })
    },
    formatDate(dateString) {
        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        const seconds = ('0' + date.getSeconds()).slice(-2);

        return `${day}-${month}-${year}`;
    },
    togglePrivilleges(code_priv){
        if (this.kodPrivGroupes.includes(code_priv)) {
        // Si le code de privilège est présent, appeler la fonction de suppression
            this.removePrivilleges(code_priv);
      } else {
        // Sinon, appeler la fonction d'ajout
        this.addPrivilleges(code_priv);
      }
    },
    loadAllUsers(){
        axios.get(`${base_url}/users`,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
              .then((response)=>{
                  if(response.status==200){
                    console.log('ALl Users!!');
                    
                    console.log(response.data.users);
                      this.users = response.data.users;
                      this.message_addUser = null;
                      this.kodUserForAdd=null;
                      console.log(this.users);
                      
                      
                  }                
              })
              .catch((error)=>{
                if(error?.response?.status === 403){
                        console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
                }
                else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                } 
              });
    },
    onSelectUserChange() {
        // Récupérer la valeur sélectionnée avec Select2
            const selectedUser = $(this.$refs.selectUser).val();
            this.kodUserForAdd = selectedUser;
            // console.log(selectedUser);
            // console.log(this.kodUserForAdd);
    },
    addUserFromGroup(){
          const $data ={
              groupe_id : +this.info.id,
              user_id : +this.kodUserForAdd
            };
            
        // console.log($data);
        // return false;
          axios.post(`${base_url}/addUserFromGroup`,$data,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
          .then((response)=>{
            //   console.log(response.data);
              if(response?.status==200){
                  this.message_addUser = "Utilisateur ajouté avec success!";
                  let self = this;
                    setTimeout(function() {
                        $('#closeModalAddUserInGroup').trigger('click');
                    },2000);
                  this.loadGroupUsers();
              }
          })
          .catch((error)=>{
            if(error?.response?.status === 403){
                        console.log('NO access');
                        let self = this;
                        $('#closeModalAddUserInGroup').trigger('click');
                    $('#openModalNoAccess').trigger('click');       
                }
                else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                }
                
          })
    },
    removeUserFromGroup(code_user){
        const $data ={
            groupe_id : +this.info.id,
            user_id : +code_user
        };
        // console.log($data);
        axios.post(`${base_url}/removeUserFromGroup`,$data,{
            headers:{
                Accept:'application/json',
                'Content-Type':'application/json;charset=UTF-8',
                Authorization:`Bearer ${this.accessToken}`
            }
        })
        .then((response)=>{
            // console.log(response.data.message);
            if(response?.status==200){
                this.loadGroupUsers();
                this.reloadKey+=1;
            }
        })
        .catch((error)=>{
            if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalButton').trigger('click');
                    this.reloadKey+=1;
            }
            else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
            }
            
        })
    },
    loadGroupUsers(){

        axios.get(`${base_url}/groupUsers?code=${this.info.id}`,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
              .then((response)=>{
                  if(response.status==200){
                    // console.log('gROUPE uTILISATEURS');
                    
                    // console.log(response.data);
                    this.groupUsers = response.data;
                  }                
              })
              .catch((error)=>{
                  console.log('Une erreur est survenue!');
                  console.error(error); 
              });
    },
    loadGroupPrivilleges(){
        axios.get(`${base_url}/privillegesGroup?code=${this.info.id}`,{
            headers:{
                Accept:'application/json',
                'Content-Type':'application/json;charset=UTF-8',
                Authorization:`Bearer ${this.accessToken}`
            }
        })
            .then((response)=>{
                if(response.status==200){
                    this.kodPrivGroupes = response.data.map(code=>code.code_privillege);
                }                
            })
            .catch((error)=>{
                if(error?.response?.status === 403){
                        // this.$router.push('/no-access');
                        console.log('NO access');
                        $('#openModalButton').trigger('click');
                }
                else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                } 
            });
    },
    loadAllPrivilleges(){
        axios.get(`${base_url}/all_privillege`,{
            headers:{
                Accept:'application/json',
                'Content-Type':'application/json;charset=UTF-8',
                Authorization:`Bearer ${this.accessToken}`
            }
        })
            .then((response)=>{
                console.log('allPrivilleges');
                
                console.log(response.data);
                if(response.status==200){
                    this.privilleges = response.data;
                }                
            })
            .catch((error)=>{
                if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                }
                else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                }  
            });
    },
    loadInfoGroup(){
        axios.get(`${base_url}/infoGroupe?code=${this.info.id}`,{
            headers:{
                Accept:'application/json',
                'Content-Type':'application/json;charset=UTF-8',
                Authorization:`Bearer ${this.accessToken}`
            }
        })
            .then((response)=>{
                if(response.status==200){
                    // console.log('InfoGroup');
                    // console.log(response.data);
                    let groupe = response.data[0];
                    // console.log(groupe);
                    this.info.nom =groupe.nom;
                    this.modifier_nom = groupe.nom;
                    this.info.description = groupe.description;
                    this.info.nom_user = groupe.nom_user;           
                    this.info.prenom_user = groupe.prenom_user;           
                    this.info.date_creation = groupe.date_creation;
                }                
            })
            .catch((error)=>{
                console.log('Une erreur est survenue!');
                console.error(error); 
            });
    },
  },
  computed: {
  availableUsers() {
    const groupUserIds = this.groupUsers.map(user => user.code_utilisateur);
    return this.users.filter(user => !groupUserIds.includes(user.id));
  }
},
  created(){
    // (JSON.parse(localStorage.getItem('user_zgc')).code_role)>3 ? this.$router.push('/'):true;
    this.info.id = this.$route.params.id;
    // console.log(this.$route.params.id);

    // const accessToken = JSON.parse(localStorage.getItem('user_zgc')).token ?? '';
        this.loadInfoGroup();
        this.loadGroupUsers();                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
        this.loadGroupPrivilleges();                                                                   
        this.loadAllPrivilleges();
  },
  mounted(){
    $('.select2').select2();
    // Ajoutez un écouteur d'événements change
    $(this.$refs.selectUser).on('change', this.onSelectUserChange);
  }
}
</script>
<style>
    .select2-container .select2-selection--single {
            height: auto;
            display: flex;
            align-items: center;
        }

        .select2-container--default .select2-selection--single .select2-selection__rendered {
            line-height: 1.5;
            text-align: center;
            white-space: normal;
        }

        .select2-dropdown {
            max-height: 200px; 
            overflow-y: auto;
            z-index: 9999; /* Pour que ca apparait sur le modal */
        }

        .select2-selection__arrow {
            height: 100%;
        }
</style>